import {
  Image
} from '@mantine/core'

import { useGetSelectData } from 'generation/centerFrontedEngine'


import { getPathToFile } from 'utils/getPathToFile'





export function SiteFaviconSync({ selectID, imageID }: { imageID: string; selectID: 'Image1' }) {
  const favicon = useGetSelectData({ modelID: imageID, selectID })

  return <Image width={24} height={24} src={getPathToFile({ fileName: favicon.name, folderName: favicon.folder })} />
}
